import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { SideNav, SideNavContent } from "components";
import {
  HeaderDasNew,
  MainBody,
  OverlayLoader,
  PageTitle,
  Ptag,
} from "components/core";
import {
  MaterialTable,
  MaterialTableContainer,
} from "components/core/BaseTable/styles";
import EditIcon from "assets/svgs/editPencilBlue.svg";
import { Link } from "pages/EnrolmentHistory/styles";
import React, { useEffect, useState } from "react";
import http from "services/httpService";
import { formatDateReverse, getFileNameFromUrl } from "utlis/utils";
import { Icon } from "pages/GmcPaymentSummary/styles";
import { set } from "lodash";
import SingleDialogBox from "components/UniversalComponents/SingleDialogBox";
import { colors } from "theme";
import PageHeader from "components/UniversalComponents/PageHeader";
import EmptyDataLottie from "components/EmptyDataLottie";
import moment from "moment";

const HEADERS = [
  "Batch Number",
  "Total Employees",
  "Upload Date",
  "File Uploaded",
  "Cut-Off Date",
  "Employee Confirmations",
  "",
];

function DataCollectionHistory() {
  const [loading, setLoading] = useState(true);
  const [tableData, setTableData] = useState();
  const [open, setOpen] = useState(false);
  const [taskIdData, setTaskIdData] = useState();
  const [emptyData, setEmptyData] = useState();
  const companyName = localStorage.getItem("company_name");
  useEffect(async () => {
    setLoading(true);
    try {
      const { data } = await http.get("business/data_collection_history_info/");
      if (data == "No Batches to Show") {
        setEmptyData(true);
      }
      setTableData(data);
      setLoading(false);
    } catch (e) {
      console.log(e);
    }
  }, []);

  const generateFile = async (value) => {
    let { data } = await http.post(
      "business/download_mis_for_data_collection/",
      { async_task_id: value },
      { responseType: "blob" }
    );
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(new Blob([data]));
    link.download = "collected_data.xlsx";

    // Append link to the DOM and click it
    document.body.appendChild(link);
    link.click();

    // Clean up
    document.body.removeChild(link);
    window.URL.revokeObjectURL(link.href);
  };

  const showEdit = (cutoffDate) => {
    const dateToCheck = moment(cutoffDate, 'DD/MM/YYYY', true); // 'true' ensures strict parsing

    if (!dateToCheck.isValid()) return false;

    // Get the current date as a Moment object
    const currentDate = moment().startOf('day'); // Get the start of the current day

    if (dateToCheck.isBefore(currentDate)) {
        return false;
    } else {
        return true;
    }
  };

  return (
    <>
      {loading ? (
        <OverlayLoader />
      ) : (
        <>
          <SideNav>
            <SideNavContent />
          </SideNav>
          <HeaderDasNew company_name={companyName} />
          <MainBody>
            {/* <Ptag fontWeight="800" fontSize="20px" marginBottom="24px">
              Collection History
            </Ptag> */}
            <PageHeader header={"Collection History"} />
            {tableData === "No Batches to Show" ? (
              <EmptyDataLottie text="No Data Available" />
            ) : (
              <TableContainer sx={MaterialTableContainer}>
                <Table aria-balel="simple table" sx={MaterialTable}>
                  <TableHead>
                    <TableRow>
                      {HEADERS.map((header, index) => (
                        <TableCell
                          key={index}
                          variant="head"
                          align="center"
                          sx={HeaderRow}
                        >
                          {header}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {tableData &&
                      typeof tableData === "object" &&
                      tableData.map((value, index) => (
                        <TableRow
                          key={index}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                        >
                          <TableCell align="center" component="th" scope="row">
                            <Ptag
                              style={{ display: "inline" }}
                            >{`Batch ${value["Batch Number"]}`}</Ptag>
                          </TableCell>
                          <TableCell align="center" component="th" scope="row">
                            <Ptag style={{ display: "inline" }}>
                              {value["Total Employees Count"]}
                            </Ptag>
                          </TableCell>
                          <TableCell align="center">
                            <Ptag style={{ display: "inline" }}>
                              {value["File Upload Date"] &&
                                formatDateReverse(value["File Upload Date"])}
                            </Ptag>
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            <Link href={value["File Uploaded"]}>
                              {getFileNameFromUrl(value["File Uploaded"])}
                            </Link>
                          </TableCell>
                          <TableCell align="center">
                            <div
                              style={{
                                display: "inline-flex",
                                gap: "1rem",
                                alignItems: "center",
                              }}
                            >
                              <Ptag style={{ display: "inline" }}>
                                {value["File Upload Date"] &&
                                  formatDateReverse(value["Cut-Off Date"])}
                              </Ptag>{" "}
                              {showEdit(
                                formatDateReverse(value["Cut-Off Date"])
                              ) && (
                                <Icon
                                  src={EditIcon}
                                  style={{
                                    height: "1.5rem",
                                    width: "1.5rem",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    setOpen((val) => !val);
                                    setTaskIdData(value);
                                  }}
                                />
                              )}
                            </div>
                          </TableCell>
                          <TableCell align="center" component="th" scope="row">
                            <Ptag style={{ display: "inline" }}>
                              {value["Confirmed Employees Count"]}
                            </Ptag>
                          </TableCell>
                          <TableCell align="center">
                            <Ptag
                              style={{ display: "inline", cursor: "pointer" }}
                              color="#4A90E2"
                              onClick={() => generateFile(value.async_task_id)}
                            >
                              Download File
                            </Ptag>
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
            {open && (
              <>
                <SingleDialogBox
                  open={open}
                  close={setOpen}
                  taskData={taskIdData}
                />
              </>
            )}
          </MainBody>
        </>
      )}
    </>
  );
}

export default DataCollectionHistory;

export const HeaderRow = {
  backgroundColor: "rgb(241, 243, 246)",
  borderBottom: "none",
  fontFamily: "Inter",
  // whiteSpace: "nowrap",
  color: colors.primaryColor,
  paddingTop: "24px",
  paddingBottom: "24px",
  overflow: "hidden",
  wordWrap: "break-word",
};
